import { IFilter } from "../interfaces/IFilter";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const create = async (data: any) => {
  return httpRequest.post(`/api/program/program`, data);
};

export const update = async (id: string, data: any) => {
  return httpRequest.put(`/api/program/program/${id}`, data);
};

export const list = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/api/program/program", { offset, filter });
};

export const get = async (id: string) => {
  return httpRequest.get(`/api/program/${id}`);
};

export const select = async (data: any) => {
  return httpRequest.get(`/api/program/program/select`, data);
};

export const anchorSelect = async (data: any) => {
  return httpRequest.get(`/api/program/program/anchor_select`, data);
};

export const anchorList = ({ offset, filter }: IFilter) => {
  return httpRequest.get("/api/program/program/anchor", { offset, filter });
};

export const anchorAdd = async (id: string, data: { businessId: string; inAccId: string; outAccId: string }) => {
  return httpRequest.put(`/api/program/program/${id}/anchor`, data);
};

export const smeSelect = async ({ offset, filter }: IFilter) => {
  return httpRequest.get(`/api/program/program/sme`, { offset, filter });
};

export const participantAdd = async (id: string, data: any) => {
  return httpRequest.put(`/api/program/program/${id}/participant`, data);
};

export const toReview = async (id: string) => {
  return httpRequest.put(`/api/program/program/${id}/to_review`);
};

export const review = async (
  id: string,
  data: {
    review: boolean;
    reviewDesc: string;
  },
) => {
  return httpRequest.put(`/api/program/program/${id}/review`, data);
};

export const reviewSme = async (
  id: string,
  data: {
    review: boolean;
    suggestAmount: number;
  },
) => {
  return httpRequest.put(`/api/program/program/${id}/review_sme`, data);
};

export const active = async (
  id: string,
  data: {
    activeType: string;
    statusDesc: string;
  },
) => {
  return httpRequest.put(`/api/program/program/${id}/active`, data);
};

export const inactive = async (
  id: string,
  data: {
    inactiveType: string;
    statusDesc: string;
  },
) => {
  return httpRequest.put(`/api/program/program/${id}/inactive`, data);
};

export const remove = async (id: string) => {
  return httpRequest.del(`/api/program/program/${id}`);
};

export const anchorRemove = async (
  id: string,
  data: {
    businessId: string;
  },
) => {
  return httpRequest.del(`/api/program/program/${id}/anchor`, data);
};

export const limit_usage = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/api/limit_usage", { offset, filter });
};
